import { render, staticRenderFns } from "./SupplierProducts.vue?vue&type=template&id=1d05501b&scoped=true&"
import script from "./SupplierProducts.vue?vue&type=script&lang=js&"
export * from "./SupplierProducts.vue?vue&type=script&lang=js&"
import style0 from "./SupplierProducts.vue?vue&type=style&index=0&id=1d05501b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d05501b",
  null
  
)

export default component.exports